var O = Object.defineProperty;
var j = (r) => {
  throw TypeError(r);
};
var F = (r, t, e) => t in r ? O(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var m = (r, t, e) => F(r, typeof t != "symbol" ? t + "" : t, e), S = (r, t, e) => t.has(r) || j("Cannot " + e);
var u = (r, t, e) => (S(r, t, "read from private field"), e ? e.call(r) : t.get(r)), P = (r, t, e) => t.has(r) ? j("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(r) : t.set(r, e), v = (r, t, e, a) => (S(r, t, "write to private field"), a ? a.call(r, e) : t.set(r, e), e);
import * as h from "three";
class w extends Error {
  constructor(t, e) {
    super(t, e), this.name = "LumiDBError";
  }
}
class n extends w {
  constructor(e, a, s) {
    super(e, s);
    m(this, "name");
    m(this, "statusCode");
    this.name = "LumiDBHttpError", this.statusCode = a;
  }
}
var y, c;
class q {
  /**
   * Creates a new LumiDB client.
   *
   * @param baseUrl LumiDB instance URL that is used for the HTTP calls.
   */
  constructor(t) {
    m(this, "baseUrl");
    P(this, y, null);
    P(this, c, null);
    this.baseUrl = t.baseUrl.replace(/\/$/, ""), t.auth && this.setAuthentication(t.auth);
  }
  /**
   * Configure authentication for the LumiDB client.
   *
   * @param config Authentication configuration. Either an API key or a function that returns a JWT token.
   */
  setAuthentication(t) {
    v(this, c, t);
  }
  /**
   * Get a listing of all accessible tables.
   *
   * @returns List of all tables.
   */
  async listTables() {
    const t = this.baseUrl + "/api/tables", e = await fetch(t, { headers: await this.getHeaders(null) });
    if (!e.ok)
      throw new n(
        `Unable to retrieve table list from LumiDB server (HTTP ${e.status}: ${e.statusText}). Check your authentication and network connection.`,
        e.status
      );
    return (await e.json()).tables.map((s) => ({
      tableName: s.name,
      tableProj: s.table_proj,
      contentAabb: s.content_aabb,
      boundsWgs84: s.bounds_wgs84,
      id: s.id,
      projectId: s.project_id
    }));
  }
  /**
   * Get an URL to download a source file.
   *
   * @param tableName LumiDB database table name.
   * @param sourceFileId Source file ID.
   * @returns Download URL and expiration time.
   */
  async getDownloadUrls(t) {
    const e = {
      table_downloads: t.tableDownloads.map((l) => ({
        table_name: l.tableName,
        files: l.files
      }))
    }, a = this.baseUrl + "/api/download_files", s = await fetch(a, {
      method: "POST",
      headers: await this.getHeaders(t.tableDownloads.map((l) => l.tableName)),
      body: JSON.stringify(e)
    });
    if (!s.ok)
      throw new n(
        `Unable to generate download URLs for the requested files (HTTP ${s.status}: ${s.statusText}). Verify that the specified tables and file IDs exist and you have access to them.`,
        s.status
      );
    return await s.json();
  }
  async getI3sSceneServerUrl(t) {
    return this.baseUrl + `/i3s/${C(t)}/SceneServer`;
  }
  /** Entwine Point Tile URL for the scene, readable by QGIS and PDAL. */
  async getEptSceneUrl(t) {
    return this.baseUrl + `/ept/${C(t)}/${N(t)}/ept.json`;
  }
  async get3DTileset(t) {
    let e = null;
    if ("uri" in t)
      e = this.baseUrl + "/api/tables/" + t.uri;
    else {
      const a = {
        ..."tableName" in t && { table_name: t.tableName },
        ..."tables" in t && { tables: t.tables },
        meta_filter: t.sourceFileFilter,
        classification_filter: t.classFilter,
        boundary: t.queryBoundary,
        boundary_proj: t.queryProj ?? "EPSG:3857",
        output_proj: t.outputProj,
        error_multiplier: t.geometricErrorMultiplier
      }, s = JSON.stringify(a), l = new TextEncoder().encode(s), d = btoa(String.fromCharCode(...l));
      e = e = `${this.baseUrl}/api/tables/3d_tileset?p=${encodeURIComponent(d)}`;
    }
    if (t.output_format === "url")
      return e;
    if (t.output_format === "json") {
      const a = [];
      "tables" in t && a.push(...t.tables), "tableName" in t && a.push(t.tableName);
      const s = await fetch(e, {
        headers: await this.getHeaders(a),
        signal: t.abortSignal
      });
      if (!s.ok)
        throw new n(
          `Failed to retrieve 3D tileset data (HTTP ${s.status}: ${s.statusText}). Check that the table exists and your query parameters are valid.`,
          s.status
        );
      return await s.json();
    } else
      throw new w("Invalid output format");
  }
  async get3DTile(t) {
    let e = this.baseUrl + "/api/tables/" + t.content.uri;
    if (t.output_type === "threejs") {
      const a = await fetch(e + "&format=threejs", {
        headers: await this.getHeaders([t.tableName]),
        signal: t.abortSignal
      });
      if (!a.ok)
        throw new n(
          `Failed to retrieve 3D tile data (HTTP ${a.status}: ${a.statusText}). Verify that the tile URI is valid and the table '${t.tableName}' is accessible.`,
          a.status
        );
      return await A(a);
    } else {
      if (t.output_type === "pnts" || t.output_type === "gltf")
        return fetch(e, {
          headers: await this.getHeaders([t.tableName]),
          signal: t.abortSignal
        });
      throw new w("Invalid output format");
    }
  }
  async query(t) {
    const {
      tableName: e,
      queryBoundary: a,
      queryProj: s = "EPSG:3857",
      maxPoints: l,
      maxDensity: d,
      sourceFileFilter: i,
      classFilter: o,
      outputProj: g = null,
      outputType: p = "threejs",
      abortSignal: _
    } = t, T = this.baseUrl + "/api/tables/query_spatial", x = {
      table_name: e,
      max_points: l,
      max_density: d ?? null,
      meta_filter: i,
      classification_filter: o,
      boundary: a,
      boundary_proj: s,
      output_proj: g,
      output_format: p === "threejs" ? "Binary" : p === "e57" ? "E57" : "Laz"
    }, b = await fetch(T, {
      signal: _,
      method: "POST",
      headers: await this.getHeaders([e]),
      body: JSON.stringify(x)
    });
    if (!b.ok)
      throw new n(
        `Spatial query failed (HTTP ${b.status}: ${b.statusText}). Check your query boundary, table name '${e}', and filter parameters. The server may have rejected the query due to size limits or invalid geometry.`,
        b.status
      );
    return p === "laz" || p === "e57" ? b : await A(b);
  }
  async createExport(t) {
    const e = this.baseUrl + "/api/export", a = {
      table_names: t.tableNames,
      max_points: t.maxPoints,
      boundary: t.queryBoundary,
      boundary_proj: t.queryProj,
      output_format: t.outputFormat,
      meta_filter: t.sourceFileFilter,
      classification_filter: t.classFilter,
      output_proj: t.outputProj,
      output_origin: t.outputOrigin
    }, s = await fetch(e, {
      signal: t.abortSignal,
      method: "POST",
      headers: await this.getHeaders(t.tableNames),
      body: JSON.stringify(a)
    });
    if (!s.ok)
      throw new n(
        `Failed to create export job (HTTP ${s.status}: ${s.statusText}). Check that the specified tables exist and your export parameters are within acceptable limits.`,
        s.status
      );
    return await s.json();
  }
  async getExportStatus(t) {
    const e = this.baseUrl + "/api/export/status/" + t, a = await fetch(e, { headers: await this.getHeaders(null) });
    if (!a.ok)
      throw new n(
        `Unable to retrieve export status for ID '${t}' (HTTP ${a.status}: ${a.statusText}). The export may not exist or may have expired.`,
        a.status
      );
    return await a.json();
  }
  async downloadExportUrl(t, e) {
    const a = this.baseUrl + "/api/export/" + t, s = await fetch(a, { headers: await this.getHeaders(null), signal: e });
    if (!s.ok)
      throw new n(
        `Unable to get download URL for export ID '${t}' (HTTP ${s.status}: ${s.statusText}). The export may not be ready, may not exist, or may have expired.`,
        s.status
      );
    return await s.json();
  }
  /**
   * Compute the volume between a point cloud surface and a base plane defined
   * by polygon vertices with Z heights.
   *
   * @param params Volume computation parameters.
   * @returns The computed volume.
   */
  async queryVolume(t) {
    const e = {
      table_names: t.tableNames,
      boundary: t.boundary,
      boundary_proj: t.boundaryProj,
      base_heights: t.baseHeights,
      classification_filter: t.classFilter ?? null,
      meta_filter: t.sourceFileFilter ?? null
    }, a = this.baseUrl + "/api/query_volume", s = await fetch(a, {
      method: "POST",
      headers: await this.getHeaders(t.tableNames),
      body: JSON.stringify(e),
      signal: t.abortSignal
    });
    if (!s.ok)
      throw new n(
        `Failed to query volume (HTTP ${s.status}: ${s.statusText}). Check your polygon boundary, table names, and base heights.`,
        s.status
      );
    return await s.json();
  }
  /**
   * Fetch metadata for multiple tables. The response includes table-level metadata like each
   * table's projection (EPSG or PROJ.4 string), the AABB of its spatial hierarchy and
   * a tighter AABB of its contents, in addition to per-file metadata as an
   * {@link SourceFileMetadata} map whose keys can be used to filter a spatial query.
   *
   * @param params Query parameters including table names and optional filters.
   * @returns Metadata for all requested tables.
   */
  async getMetadata(t) {
    const e = {
      table_names: t.tableNames,
      boundary: t.boundary ?? null,
      boundary_proj: t.boundaryProj ?? null,
      meta_filter: t.metaFilter ?? null,
      classification_filter: t.classificationFilter ?? null,
      mode: t.mode
    }, a = this.baseUrl + "/api/query_metadata", s = await fetch(a, {
      headers: await this.getHeaders(t.tableNames),
      method: "POST",
      body: JSON.stringify(e),
      signal: t.abortSignal
    });
    if (!s.ok)
      throw new n(
        `Unable to retrieve metadata for the requested tables (HTTP ${s.status}: ${s.statusText}). Verify that the table names are correct and you have access to them.`,
        s.status
      );
    return await s.json();
  }
  /**
   * Fetch metadata for a single table. This is a convenience method that wraps
   * {@link getMetadata} for single-table queries. The response includes table-level
   * metadata like the table's projection (EPSG or PROJ.4 string), the AABB of its
   * spatial hierarchy and a tighter AABB of its contents, in addition to per-file
   * metadata as an {@link SourceFileMetadata} map whose keys can be used to filter
   * a spatial query.
   *
   * @param params Query parameters for a single table.
   * @param filter Optional filters to limit the files included in the response.
   * @returns Metadata for the requested table.
   */
  async getTableMetadata(t, e) {
    return (await this.getMetadata({
      ...e,
      mode: "full",
      tableNames: [t]
    })).tables[t];
  }
  /**
   * Patch user metadata for a table. This method merges the provided user metadata
   * with the existing user metadata for the specified table using json merge patch
   * (RFC 7386) semantics.
   *
   * @param tableName Table name
   * @param userData Arbitrary metadata to patch into the table's user metadata. Use `null` values to remove existing keys.
   *
   * @returns The merged user metadata after the patch operation.
   */
  async patchTableUserData(t, e) {
    const a = this.baseUrl + "/api/patch_user_metadata", s = await fetch(a, {
      headers: await this.getHeaders([t]),
      method: "PATCH",
      body: JSON.stringify({
        table_name: t,
        user_data: e
      })
    });
    if (!s.ok)
      throw new n(
        `Unable to patch user metadata for table '${t}' (HTTP ${s.status}: ${s.statusText}). Verify that the table name is correct and you have access to it.`,
        s.status
      );
    return await s.json();
  }
  /**
   * Patch user metadata for a raster dataset. Merges the provided values
   * with the existing user metadata using json merge patch (RFC 7386).
   *
   * @param rasterName Raster dataset name.
   * @param userData Arbitrary metadata to patch. Use `null` values to remove existing keys.
   *
   * @returns The merged user metadata after the patch operation.
   */
  async patchRasterUserMetadata(t, e) {
    const a = this.baseUrl + `/api/rasters/${encodeURIComponent(t)}/metadata`, s = await fetch(a, {
      headers: await this.getHeaders(null),
      method: "PATCH",
      body: JSON.stringify(e)
    });
    if (!s.ok)
      throw new n(
        `Unable to patch user metadata for raster '${t}' (HTTP ${s.status}: ${s.statusText}). Verify that the raster name is correct and you have access to it.`,
        s.status
      );
    return await s.json();
  }
  /**
   * Resolve a short-lived presigned URL for the merged COG. Useful for GDAL
   * /vsicurl streaming or direct download.
   */
  async getRasterCogUrl(t) {
    const e = this.baseUrl + `/api/rasters/${encodeURIComponent(t)}/cog`, a = await fetch(e, { headers: await this.getHeaders(null) });
    if (!a.ok)
      throw new n(
        `Unable to resolve raster COG URL (HTTP ${a.status}: ${a.statusText}).`,
        a.status
      );
    return await a.json();
  }
  /**
   * Get a presigned download URL for one of a raster's original source files.
   */
  async getRasterDownloadUrl(t, e) {
    const a = this.baseUrl + `/api/rasters/${encodeURIComponent(t)}/download/${e}`, s = await fetch(a, { headers: await this.getHeaders(null) });
    if (!s.ok)
      throw new n(
        `Unable to generate a download URL for raster '${t}' (HTTP ${s.status}: ${s.statusText}). Verify that the raster name and file exist and you have access to them.`,
        s.status
      );
    return await s.json();
  }
  /**
   * Create an attachment from one uploaded asset. The server reads the
   * filename and the size from the asset, thus only its id is sent.
   */
  async createAttachment(t) {
    const e = this.baseUrl + "/api/attachments", a = await fetch(e, {
      headers: await this.getHeaders(null),
      method: "POST",
      body: JSON.stringify(t)
    });
    if (!a.ok)
      throw new n(
        `Unable to create an attachment from asset '${t.asset_id}' (HTTP ${a.status}: ${a.statusText}).`,
        a.status
      );
    return await a.json();
  }
  /**
   * Rename an attachment and/or patch its user metadata. The metadata is a
   * json merge patch (RFC 7386); a `null` value removes a key.
   */
  async patchAttachment(t, e) {
    const a = this.baseUrl + `/api/attachments/${t}`, s = await fetch(a, {
      headers: await this.getHeaders(null),
      method: "PATCH",
      body: JSON.stringify(e)
    });
    if (!s.ok)
      throw new n(
        `Unable to patch attachment '${t}' (HTTP ${s.status}: ${s.statusText}).`,
        s.status
      );
    return await s.json();
  }
  /**
   * Delete an attachment. The asset that holds the file stays, as with a
   * dataset or a raster.
   */
  async deleteAttachment(t) {
    const e = this.baseUrl + `/api/attachments/${t}`, a = await fetch(e, {
      headers: await this.getHeaders(null),
      method: "DELETE"
    });
    if (!a.ok)
      throw new n(
        `Unable to delete attachment '${t}' (HTTP ${a.status}: ${a.statusText}).`,
        a.status
      );
  }
  /**
   * Get a presigned download URL for the file of an attachment.
   */
  async getAttachmentDownloadUrl(t) {
    const e = this.baseUrl + `/api/attachments/${t}/download`, a = await fetch(e, { headers: await this.getHeaders(null) });
    if (!a.ok)
      throw new n(
        `Unable to generate a download URL for attachment '${t}' (HTTP ${a.status}: ${a.statusText}).`,
        a.status
      );
    return await a.json();
  }
  async getHeaders(t) {
    if (!u(this, c))
      throw new w("No authentication method configured.");
    let e = "";
    if ("apikey" in u(this, c))
      e = `apikey ${u(this, c).apikey}`;
    else if ("link" in u(this, c))
      e = `link ${u(this, c).link}`;
    else {
      const a = await this.fetchToken(t);
      e = `${u(this, c).type ?? "bearer"} ${a}`;
    }
    return {
      "Content-Type": "application/json",
      "X-LumiDB-Client": "npm 0.7.2",
      Authorization: e
    };
  }
  async fetchToken(t) {
    if (!u(this, c) || !("getTokenCallback" in u(this, c)))
      throw new w("No authentication method configured.");
    if (u(this, y)) {
      const a = I(u(this, y));
      if (a) {
        const s = t === null || t.every((i) => a.scopes.includes(i));
        if (a.exp - Date.now() / 1e3 > 10 && s)
          return u(this, y);
      }
    }
    const e = await u(this, c).getTokenCallback();
    if (typeof e != "string")
      throw new w("getTokenCallback() did not return a string.");
    return v(this, y, e), u(this, y);
  }
}
y = new WeakMap(), c = new WeakMap();
function C(r) {
  const t = {};
  t.tables = r.tables, r.queryBoundary && (t.boundary = r.queryBoundary), r.queryProj && (t.boundary_proj = r.queryProj), r.sourceFileFilter && (t.meta_filter = r.sourceFileFilter), r.classFilter && (t.classification_filter = r.classFilter), r.outputProj && (t.output_proj = r.outputProj);
  const e = new TextEncoder().encode(JSON.stringify(t)), a = btoa(String.fromCharCode(...e)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""), s = Math.random().toString(36).slice(2, 10);
  return `${a}.${s}`;
}
function N(r) {
  const e = r.tables.map(
    (d) => d.replace(/[^A-Za-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80)
  ).filter(Boolean), a = [];
  let s = 0;
  for (const d of e) {
    if (a.length > 0 && s + d.length >= 80) break;
    a.push(d), s += d.length + 1;
  }
  const l = e.length - a.length;
  return [a.join("_") || "pointcloud", l > 0 && `and_${l}_more`, r.queryBoundary && "clip"].filter(Boolean).join("_");
}
function I(r) {
  try {
    const t = r.split(".")[1], e = JSON.parse(atob(t));
    if (typeof e == "object" && e !== null && "exp" in e && typeof e.exp == "number" && "scopes" in e && Array.isArray(e.scopes) && e.scopes.every((a) => typeof a == "string"))
      return { exp: e.exp, scopes: e.scopes };
    throw new w("Invalid JWT structure");
  } catch {
    return null;
  }
}
async function A(r) {
  const t = await r.arrayBuffer();
  let e = 0;
  const a = new DataView(t, 0, 8);
  e += 8;
  const s = a.getBigInt64(0, !0), l = Number(s), d = new TextDecoder().decode(t.slice(8, 8 + l));
  e += l;
  const i = JSON.parse(d), o = i.point_count;
  e += 8 - e % 8;
  const g = new Float32Array(t, e, 3 * o);
  e += 4 * 3 * o;
  const p = new Uint32Array(t, e, o);
  e += 4 * o;
  const _ = new Uint8Array(t, e, o);
  e += o;
  const T = new Uint8Array(t, e, 3 * o);
  e += 3 * o;
  const x = new Uint16Array(t, e, o);
  e += 2 * o;
  const b = new Uint16Array(t, e, o);
  e += 2 * o;
  const f = new h.BufferGeometry();
  if (f.setAttribute("position", new h.Float32BufferAttribute(g, 3)), f.setAttribute("source_file_id", new h.Int32BufferAttribute(p, 1, !1)), f.setAttribute("classification", new h.Uint8BufferAttribute(_, 1, !1)), f.setAttribute("color", new h.Uint8BufferAttribute(T, 3, !0)), f.setAttribute("intensity", new h.Uint16BufferAttribute(x, 1, !0)), f.setAttribute("point_source_id", new h.Uint16BufferAttribute(b, 1, !1)), i.has_extra_data) {
    const k = new Uint16Array(t, e, o);
    e += 2 * o, f.setAttribute("extra_data", new h.Uint16BufferAttribute(k, 1, !0));
  }
  let U;
  i.has_object_ids ? (U = new Int32Array(t, e, o), e += 4 * o) : U = new Int32Array(o).fill(-1), f.setAttribute("object_id", new h.Int32BufferAttribute(U, 1, !1));
  let $;
  return i.has_hag ? ($ = new Float32Array(t, e, o), e += 4 * o) : $ = new Float32Array(o), f.setAttribute("hag", new h.Float32BufferAttribute($, 1, !1)), {
    pointGeometry: f,
    pointCount: o,
    bytes: t.byteLength,
    sourceFileIds: i.file_ids,
    offset: i.query_offset,
    queryCenter: i.query_center,
    queryArea: i.query_area,
    classifications: i.classifications,
    intensityRange: i.intensity_range,
    bounds: i.bounds,
    processingTimeMs: i.processing_time_ms
  };
}
const H = {
  rgb: 1,
  classification: 2,
  intensity: 3,
  // TODO: make these names harder to mix up
  point_source_id: 4,
  source_file_id: 5
};
class D extends h.ShaderMaterial {
  constructor(t = {}) {
    super({
      glslVersion: "300 es",
      uniforms: {
        pointSize: { value: t.pointSize ?? 4 },
        colorMode: { value: H[t.colorMode ?? "rgb"] }
      },
      fragmentShader: `
            	out vec4 FragColor;
				in vec3 vColor;
				void main() {
					float u = 2.0 * gl_PointCoord.x - 1.0;
					float v = 2.0 * gl_PointCoord.y - 1.0;
					if (u * u + v * v > 1.0) { discard; }
					FragColor = vec4(vColor, 1.0);
				}
            `,
      vertexShader: `#define PI 3.141592653589793
				uniform int colorMode;
				uniform float pointSize;

                in vec3 color;
				in float classification;
				in float point_source_id;
				in int source_file_id;
				in float intensity;

                out vec3 vColor;

                void main() {
                    mat4 modelToScreen = projectionMatrix * modelViewMatrix;
                    vec4 screenPosition = modelToScreen * vec4(position, 1.0);
                    gl_PointSize = pointSize;
                    gl_Position = screenPosition;
					if (colorMode == 1) {
						/* RGB */
						vColor = color;
					} else if (colorMode == 2) {
						/* CLASSIFICATION */
						float O = 0.25;
						float x = float(classification) / 16.0;
						float r = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.00 + O));
						float g = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.66 + O));
						float b = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.33 + O));
						vColor = vec3(r, g, b);
					} else if (colorMode == 3) {
						/* INTENSITY */
						vColor = vec3(intensity * 256.0);
					} else if (colorMode == 4) {
						/* POINT SOURCE ID */
						float O = 0.25;
						float x = float(point_source_id) / 16.0;
						float r = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.00 + O));
						float g = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.66 + O));
						float b = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.33 + O));
						vColor = vec3(r, g, b);
					} else if (colorMode == 5) {
						/* SOURCE FILE ID */
						float O = 0.25;
						float x = float(source_file_id) / 16.0;
						float r = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.00 + O));
						float g = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.66 + O));
						float b = 0.5 + 0.5 * cos(2.0 * PI * (3.0 * x + 0.33 + O));
						vColor = vec3(r, g, b);
					} else {
						vColor = vec3(1.0, 0.0, 0.0);
					}
                }
            `
    });
  }
  /**
   * Change color mode. Modes are based on the {@link ThreeJsResponse.pointGeometry} attributes.
   *
   * @param colorMode The color mode to use.
   */
  setColorMode(t) {
    this.uniforms.colorMode.value = H[t];
  }
  /**
   * Change point size.
   *
   * @param pointSize The size of the points in pixels.
   */
  setPointSize(t) {
    this.uniforms.pointSize.value = t;
  }
}
export {
  q as LumiDB,
  w as LumiDBError,
  n as LumiDBHttpError,
  D as PointCloudMaterial
};
//# sourceMappingURL=lumidb.js.map
